/**
 * @class ConfigurationManager
 * @description Manage all the aspects related to configuration manipulation
 */
export default class ConfigurationManager {
  constructor(config) {
    if (!this.validate(config)) {
      throw new Error('[RcsOrchestrator] Configuration not valid');
    }
    this.config = config;
  }

  getComponents() {
    let flavor = this.getFlavor();
    if (!flavor) return this.config.components;
    let components = [];
    this.config.components.forEach(component => {
      if (!component.flavors || component.flavors.indexOf(flavor) > -1) {
        components.push(component);
      }
    });
    return components;
  }

  getFlavor() {
    return this.config.getFlavor ? this.config.getFlavor() : null;
  }

  /**
   * Validate the minimum requirement for config
   * @param {Object} config
   * @returns {Boolean} true if configuration is valid
   */
  validate(config) {
    if (config && config.components) {
      return true;
    }
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/rcs-orchestrator/utils/ConfigurationManager.js